import { render, staticRenderFns } from "./_document-form.vue?vue&type=template&id=6daaed05&scoped=true&"
import script from "./_document-form.vue?vue&type=script&lang=js&"
export * from "./_document-form.vue?vue&type=script&lang=js&"
import style0 from "./_document-form.vue?vue&type=style&index=0&id=6daaed05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daaed05",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VForm,VLabel,VOverlay,VRow,VTextField})
